export default __webpack_public_path__ + "static/media/double-arrow.15a80bec.svg";